var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.98993L19.5301 17.9999H4.47012L12.0001 4.98993ZM2.74012 16.9999C1.97012 18.3299 2.93012 19.9999 4.47012 19.9999H19.5301C21.0701 19.9999 22.0301 18.3299 21.2601 16.9999L13.7301 3.98993C12.9601 2.65993 11.0401 2.65993 10.2701 3.98993L2.74012 16.9999ZM11.0001 9.99993V11.9999C11.0001 12.5499 11.4501 12.9999 12.0001 12.9999C12.5501 12.9999 13.0001 12.5499 13.0001 11.9999V9.99993C13.0001 9.44993 12.5501 8.99993 12.0001 8.99993C11.4501 8.99993 11.0001 9.44993 11.0001 9.99993ZM11.0001 14.9999H13.0001V16.9999H11.0001V14.9999Z",
    fill: "#826100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRounded);
export default __webpack_public_path__ + "static/media/warning_rounded.0fa4cedcf213ef0e9abe5dcbde143773.svg";
export { ForwardRef as ReactComponent };